<script>
export default {
  name: "EnSalads",
  data() {
    return {
      salads: [
        {
          name: "Vitamin salad",
          text: "Lettuce, cabbage, carrot, salad dressing",
          price: "90 den.",
        },
        {
          name: "Cesar salad",
          text: "Lettuce, chicken, bread cubes, cherry tomato, parmesan, corn, salad dressing",
          price: "170 den.",
        },
        {
          name: "Tuna salad",
          text: "Lettuce, tuna, onions, cherry tomato, corn, salad dressing",
          price: "220 den.",
        },
      ],
    };
  },
}
</script>

<template>
<div class="main">
  <base-card v-for="salad in salads" :key="salad.name">
    <v-card-title>{{ salad.name }}</v-card-title>
    <v-card-text>{{ salad.text }}</v-card-text>
    <v-card-actions class="flex text-right"
    ><v-spacer></v-spacer>{{ salad.price }}</v-card-actions
    >
  </base-card>
</div>
</template>

<style scoped>
.main {
  min-height: 100vh;
  background: transparent;
}
</style>